// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"36":"14e2287f86d18372","206":"b4fd947b8468ace5","805":"311235b6aa5afb9e","961":"ab21d31011d6378f"}[chunkId] + ".js";
};